<template>
  <BasicForm v-bind="getBindValue" @register="emitRegister">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </BasicForm>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { Recordable } from '@mts-fe/types';
  import {
    BasicForm,
    FormActionType,
    FormProps,
    FormSchemaInner,
    useForm,
  } from '@mts/components/Form';
  import { FORM_EMIT_EVENTS, useFormEvents } from '@mts/render/hooks/useRenderForm';
  import { PADMode } from '@mts/utils/env';

  defineOptions({
    name: 'SearchForm',
  });

  const props = withDefaults(
    defineProps<Omit<FormProps, 'schemas'> & { schemas?: FormSchemaInner[] }>(),
    {
      layout: 'inline',
      strongRelate: true,
      autoSetPlaceHolder: true,
      rulesMessageJoinLabel: true,
      showActionButtonGroup: true,
      showSubmitButton: true,
      showMoreButton: false,
      actionColOptions: () => ({ span: 0 }),
      compact: true,
      hideLabel: PADMode,
    },
  );
  const emit = defineEmits(['register', 'update:model', ...FORM_EMIT_EVENTS]);
  const bindFormEvents = useFormEvents(emit, (evt: string, ...args: Recordable[]) => {
    ['change', 'submit'].includes(evt) && emit('update:model', args[0]);
  });
  const [registerForm, formAction] = useForm();
  const emitRegister = (...args: Recordable[]) => (
    registerForm(args[0] as FormActionType),
    emit('register', ...args)
  );
  const setProps: (typeof formAction)['setProps'] = async (formProps) => {
    await formAction.setProps(formProps);
  };
  defineExpose({ ...formAction, setProps });

  const getBindValue = computed(() => {
    return {
      ...props,
      ...bindFormEvents,
    };
  });
</script>
